const botResponses = [
  {
    triggers: ["hola", "hi", "hello", "buenas"],
    reply: "¡Hola! ¿En qué puedo ayudarte? 👋 Puedes preguntar por servicios, horarios o ubicaciones.",
  },
  {
    triggers: ["horario", "horarios", "schedule"],
    reply: "🕒 Horarios: Lunes a Viernes 7:00–3:00, Sábado 7:00–11:00.",
  },
  {
    triggers: ["ubicacion", "ubicaciones", "donde", "where"],
    reply: "📍 Estamos en Medicentro La Esperanza y en Humana Centro Médico (San Benito).",
  },
  {
    triggers: ["cita", "agendar", "appointment", "book"],
    reply: "📅 Puedes agendar desde el botón de WhatsApp o la sección “Agendar Cita”.",
  },
  {
    triggers: ["servicio", "servicios", "services"],
    reply: "🔧 Servicios: Examen de vista, LASIK, cataratas, glaucoma, retina y más.",
  },

  // 🔽 NUEVAS PREGUNTAS FRECUENTES
  {
    triggers: ["pago", "pagos", "metodos de pago"],
    reply: "💳 Aceptamos efectivo, tarjetas de crédito/débito.",
  },
  {
    triggers: ["precio", "precios", "costo", "cuanto"],
    reply: "💰 Los precios varían según el servicio. Pregúntame por uno en específico.",
  },
  {
    triggers: ["lentes", "marcas", "productos"],
    reply: "👓 Puedes ver todas las marcas y equipos en el Catálogo de Productos.",
  },
  {
    triggers: ["tiempo", "tarda", "duracion"],
    reply: "⏱ La mayoría de exámenes dura de 15 a 25 minutos.",
  },
  {
    triggers: ["laser", "lasik", "cirugia"],
    reply: "🔬 Sí, realizamos procedimientos láser como LASIK y PRK.",
  },
  {
    triggers: ["whatsapp", "mensaje"],
    reply: "📲 Puedes escribirnos por WhatsApp desde la web.",
  },
  {
    triggers: ["doctor", "especialista"],
    reply: "👨‍⚕️ Nuestros especialistas están certificados y con amplia experiencia.",
  },
];

export default botResponses;
